import React, { useEffect, useState } from 'react'

const CountdownTimer = ({
  time,
  setTimerDone,
  setTime,
}: {
  time: number
  setTimerDone?: React.Dispatch<React.SetStateAction<boolean>>
  setTime?: React.Dispatch<React.SetStateAction<number>>
}) => {
  // Define the end time in one hour from now
  const endTime = new Date().getTime() + time * 1000

  const [timer, setTimer] = useState<number>(endTime - new Date().getTime())

  useEffect(() => {
    // Update the timer every second
    const interval = setInterval(() => {
      const timeLeft = endTime - new Date().getTime()

      // Stop the timer when it reaches 0
      if (timeLeft < 0) {
        clearInterval(interval)
        setTimer(0)
        if (setTimerDone && setTime) {
          setTimerDone(true)
          setTime(0)
        }
      } else {
        setTimer(timeLeft)
      }
    }, 1000)

    // Clear the interval when the component is unmounted
    return () => clearInterval(interval)
  }, [])

  // const hours = Math.floor(timer / (1000 * 60 * 60));
  const minutes = Math.floor((timer / (1000 * 60)) % 60)
  const seconds = Math.floor((timer / 1000) % 60)

  return (
    <p className="text-sm text-main-blue">
      {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
    </p>
  )
}

export default CountdownTimer
